import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'usuario', namespaced: true })

export default mystore
